import __request__ from 'routing/request';
/**
 * Get active authentication service backend
 */
export function get(): Promise<unknown> {
    return __request__('GET', '/system/authentication/services/active-backend', null, {}, {
        'Accept': ['application/json']
    });
}
